angular.module('core')
  .service('dblAstApi', ['cancelableResourceFactory', 'cancelableResourceManager', function (dblCancelableResourceFactory, dblCancelableResourceManager) {

    var Ast = dblCancelableResourceFactory.createCacheableResource(null, '/m/ast/:ast/tree/domains', {}, {
      get: {
        url: '/m/ast/:ast/tree/domains',
        method: 'GET',
        isArray: false,
        cache: true
      }
    });

    var getAst = function (ast, days, sy, fd, td) {
        var params = {
            ast: ast,
            untilNow: true,
            days: days,
            sy: sy,
            fd: fd,
            td: td
        };

        var resource = Ast.get(params);
        dblCancelableResourceManager.addAndRemoveOnFinish(resource);

        return resource.$promise;
    };

    return {
        getAst: getAst
    };
}]);
